"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.LogoutFunctionality = void 0;
var React = _interopRequireWildcard(require("react"));
var _hoc = require("@apollo/client/react/hoc");
var _jsCookie = _interopRequireDefault(require("js-cookie"));
var _flowRight = _interopRequireDefault(require("lodash/flowRight"));
var _browserStorage = _interopRequireDefault(require("../../../../../../utils/browserStorage"));
var _withAppConfig = _interopRequireDefault(require("../../../../../HOCs/withAppConfig"));
var _withHeaderApi = _interopRequireDefault(require("../../../../../HOCs/withHeaderApi"));
var _WalkMe = require("../../../../../WalkMe");
var _Functionality = require("../Functionality.style");
const LogoutFunctionality = _ref => {
  let {
    client,
    appConfig,
    children,
    headerApi
  } = _ref;
  const store = (0, _browserStorage.default)();
  const handleLogoutClick = async () => {
    store.clear();
    _jsCookie.default.remove('icis.cache', {
      domain: appConfig.urls.authDomain
    });
    _jsCookie.default.remove(_WalkMe.walkMeSessionCookie, {
      domain: appConfig.urls.authDomain
    });
    _jsCookie.default.remove('icis.troubleShootingLocale', {
      domain: appConfig.urls.authDomain
    });
    await client.clearStore();
    headerApi === null || headerApi === void 0 ? void 0 : headerApi.onLogout();
  };
  return /*#__PURE__*/React.createElement(_Functionality.NavItemButton, {
    onClick: handleLogoutClick
  }, children);
};
exports.LogoutFunctionality = LogoutFunctionality;
var _default = exports.default = (0, _flowRight.default)(_hoc.withApollo, _withAppConfig.default, _withHeaderApi.default)(LogoutFunctionality);